export default "__VITE_ASSET__BObqEUqJ__"